import * as React from "react";
const SvgFiRrHockeySticks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hockey-sticks_svg__a)">
      <path
        fill="#062147"
        d="M23.974 17.963a5.52 5.52 0 0 0-4.015-4.726L22.875 3.7A2.866 2.866 0 0 0 20.133 0a2.98 2.98 0 0 0-2.87 2.125L14.8 10.162a3.97 3.97 0 0 1-2.8 2.703 4 4 0 0 1-2.8-2.7L6.766 2.128A2.98 2.98 0 0 0 3.9 0a2.866 2.866 0 0 0-2.748 3.7l2.9 9.539A5.46 5.46 0 0 0 1.43 22.2 5.5 5.5 0 0 0 5.5 24h3.769c.927 0 1.85-.126 2.743-.377h.011c.88.25 1.792.376 2.707.377h3.77a5.5 5.5 0 0 0 5.474-6.037M3.2 2.351A.86.86 0 0 1 3.9 2a1 1 0 0 1 .957.709l2.439 8.034A6 6 0 0 0 8.562 13H6.067l-3-9.882a.86.86 0 0 1 .133-.767M5.5 22a3.5 3.5 0 0 1-3.483-3.847A3.634 3.634 0 0 1 5.693 15h5.275a5.96 5.96 0 0 0 5.74-4.254l2.467-8.034A.994.994 0 0 1 20.133 2a.867.867 0 0 1 .829 1.116l-4.038 13.208A7.95 7.95 0 0 1 9.269 22zm15.591-1.147A3.5 3.5 0 0 1 18.5 22h-3.208a9.98 9.98 0 0 0 3.545-5.093l.537-1.757a3.52 3.52 0 0 1 2.609 3 3.47 3.47 0 0 1-.892 2.703"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hockey-sticks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHockeySticks;
